<div class="finance-form">
	<!--  FINANCE LOCKED  -->

	<div *ngIf="finance_meta.locked" class="finance-locked">
		<div class="quote">
			<!--  QUOTE  -->

			<cng-finance-quote
				[locked]="true"
				[quote]="selected_quote"
				[breakdown_alignment]="lte_sm ? 'vertical' : 'horizontal'"
				[show_info]="true"
				[show_disclaimer]="true"
				(info_click)="onInfoClick(selected_quote, $event)"
				(manage_application_click)="onManageFinanceApplication()"
			></cng-finance-quote>

			<!--  END QUOTE  -->

			<div class="button-footer">
				<a
					*ngIf="selected_quote.print_url !== null"
					class="button button-with-icon-right pri-fg pri-bg"
					target="_blank"
					[attr.href]="selected_quote.print_url"
					data-element-click="button__engage_configure_finance_options[finance][finance_locked]__primary-button[Print]"
					(click)="onFinanceAction('print', selected_quote, $event)"
				>
					<i class="icon-printer"></i>
					<span class="text">Print</span>
				</a>
				<a
					*ngIf="dealer.demonstration_mode"
					class="button button-with-icon-right"
					data-element-click="button__engage_configure_finance_options[finance][finance_locked]__primary-button[Unlock Deal]"
					(click)="unlockDeal()"
				>
					<i class="icon-padlock"></i>
					<span class="text">Unlock Deal</span>
				</a>
			</div>
		</div>
	</div>

	<!--  END FINANCE LOCKED  -->

	<!--  FINANCE FORM  -->

	<form
		*ngIf="!finance_meta.locked"
		name="configure_finance_quote_form"
		[formGroup]="finance_quotes_form"
		class="form"
		(input)="onFormInput($event)"
	>
		<!-- PAYMENT OPTIONS -->

		<div class="container button-payment-options-container">
			<a
				class="button"
				[ngClass]="finance_meta.enabled ? 'primary-button' : 'minor-button'"
				data-element-click="tab__engage_configure_finance_options__[Finance]"
				(click)="onFinanceToggle('finance')"
			>
				Finance
			</a>
			<a
				class="button"
				[ngClass]="!finance_meta.enabled ? 'primary-button' : 'minor-button'"
				data-element-click="tab__engage_configure_finance_options__[Cash]"
				(click)="onFinanceToggle('cash')"
			>
				Cash
			</a>
		</div>

		<!-- END PAYMENT OPTIONS -->
		<div class="accordion checklist-accordion">
			<div class="accordion-item" [ngClass]="{ active: finance_meta.enabled }">
				<div class="accordion-item-content">
					<span *ngIf="loading" class="loading-spinner"></span>
					<div *ngIf="loading" class="loading-overlay"></div>

					<div class="heading">
						<h3 class="finance-title">Finance Payment</h3>
					</div>

					<!--  FINANCE SLIDERS  -->

					<div
						*ngIf="use_sliders"
						class="options row"
						[class.no-credit-rating]="!finance_meta.show_credit_score"
					>
						<div *ngIf="finance_meta.show_credit_score" class="col-xxs-30 col-sm-15">
							<ui-slider-control
								[form]="finance_quotes_form"
								[form_control]="finance_quotes_form.controls['credit_rating']"
								[label]="'How is your credit rating?'"
								[display_value]="credit_rating_display_value"
								[min]="1"
								[step]="1"
								[max]="finance_meta.credit_scores.length"
								(changed)="onInputChange('credit_rating')"
								(input)="setCreditRatingDisplayValue()"
							></ui-slider-control>
						</div>
						<div class="col-xxs-30 col-sm-15" [class.col-md-10]="!finance_meta.show_credit_score">
							<ui-slider-control
								[form]="finance_quotes_form"
								[form_control]="finance_quotes_form.controls['mileage']"
								[label]="'What is your annual mileage?'"
								[min]="6000"
								[step]="1000"
								[max]="60000"
								[suffix]="'miles'"
								(changed)="onInputChange('mileage')"
							></ui-slider-control>
						</div>
						<div class="col-xxs-30 col-sm-15" [class.col-md-10]="!finance_meta.show_credit_score">
							<ui-slider-control
								[form]="finance_quotes_form"
								[form_control]="finance_quotes_form.controls['deposit']"
								[label]="'How much cash deposit can you contribute?'"
								[min]="0"
								[step]="100"
								[max]="max_deposit_amount"
								[prefix]="'£'"
								(changed)="onInputChange('deposit')"
							></ui-slider-control>
						</div>
						<div class="col-xxs-30 col-sm-15" [class.col-md-10]="!finance_meta.show_credit_score">
							<ui-slider-control
								[form]="finance_quotes_form"
								[form_control]="finance_quotes_form.controls['term']"
								[label]="'How long do you wish to finance the vehicle for?'"
								[min]="terms_settings.min"
								[step]="terms_settings.step"
								[max]="terms_settings.max"
								[suffix]="'months'"
								(changed)="onInputChange('term')"
							></ui-slider-control>
						</div>
					</div>

					<!--  END FINANCE SLIDERS  -->

					<!--  FINANCE DROPDOWNS (FALLBACK)  -->

					<div
						*ngIf="!use_sliders"
						class="options row"
						[class.no-credit-rating]="!finance_meta.show_credit_score"
					>
						<div *ngIf="finance_meta.show_credit_score" class="col-xxs-30 col-sm-15">
							<ui-select-control
								[form]="finance_quotes_form"
								[form_control]="finance_quotes_form.controls['credit_rating']"
								[label]="'How is your credit rating?'"
								[options]="credit_rating_options"
								[empty_allowed]="false"
								(changed)="onInputChange()"
							></ui-select-control>
						</div>
						<div class="col-xxs-30 col-sm-15" [class.col-md-10]="!finance_meta.show_credit_score">
							<ui-select-control
								[form]="finance_quotes_form"
								[form_control]="finance_quotes_form.controls['mileage']"
								[label]="'What is your annual mileage?'"
								[options]="mileage_options"
								[empty_allowed]="false"
								[suffix]="'miles'"
								(changed)="onInputChange()"
							></ui-select-control>
						</div>
						<div class="col-xxs-30 col-sm-15" [class.col-md-10]="!finance_meta.show_credit_score">
							<ui-select-control
								[form]="finance_quotes_form"
								[form_control]="finance_quotes_form.controls['deposit']"
								[label]="'How much cash deposit can you contribute?'"
								[options]="deposit_options"
								[empty_allowed]="false"
								[prefix]="'£'"
								(changed)="onInputChange()"
							></ui-select-control>
						</div>
						<div class="col-xxs-30 col-sm-15" [class.col-md-10]="!finance_meta.show_credit_score">
							<ui-select-control
								[form]="finance_quotes_form"
								[form_control]="finance_quotes_form.controls['term']"
								[label]="'How long do you wish to finance the vehicle for?'"
								[options]="term_options"
								[empty_allowed]="false"
								[suffix]="'months'"
								(changed)="onInputChange()"
							></ui-select-control>
						</div>
					</div>

					<!--  END FINANCE DROPDOWNS (FALLBACK)  -->

					<div class="options">
						<p class="scroll-down">Scroll down to view full details...</p>
					</div>
					<div *ngIf="finance_quotes !== null && finance_quotes.length > 0" class="results row">
						<!--  QUOTES LOOP  -->

						<div *ngFor="let quote of finance_quotes" [ngClass]="finance_column_css_class">
							<div
								class="quote"
								[class.selected]="quote.selected"
								[attr.data-element-click]="
									'finance_quote__engage_configure_finance_options[finance]__[' +
									quote.facility_type.toUpperCase() +
									']'
								"
								(click)="selectQuote(quote)"
							>
								<!--  SELECTED CHECKBOX  -->

								<div class="quote-header">

										<i class="icon-tick checkbox" [class.checked]="quote.selected"></i>
										{{ quote.facility_type }}
										<span class="selected-indicator pri-fg">(Selected)</span>

									<a
										*ngIf="
											quote.apply_url !== null &&
											!(
												this.quote.quote_status === 'Approved' ||
												this.quote.quote_status === 'ConditionallyApproved'
											)
										"
										class="button button-with-icon-right positive-button apply-button"
										data-element-click="button__engage_configure_finance_options[finance][finance_quote_header]__positive-button[Apply]"
										(click)="onFinanceAction('apply', quote, $event)"
									>
										<i class="icon-send"></i>
										<span class="text">
											<span>Apply</span>
											<span *ngIf="application_minutes_to_complete" class="time-estimate hidden-xxs hidden-sm">approx. {{application_minutes_to_complete | pluralise:'minute':'+s'}}</span>
											<span *ngIf="application_minutes_to_complete" class="time-estimate visible-xxs visible-sm">{{application_minutes_to_complete | pluralise:'min':'+s'}}</span>
										</span>
									</a>
								</div>

								<!--  END SELECTED CHECKBOX  -->

								<!--  QUOTE DETAILS  -->

								<cng-finance-quote
									[quote]="quote"
									[breakdown_alignment]="
										finance_quotes.length > 1 || (finance_quotes.length === 1 && lte_sm)
											? 'vertical'
											: 'horizontal'
									"
									[show_info]="true"
									[show_disclaimer]="true"
									(info_click)="onInfoClick(quote, $event)"
								></cng-finance-quote>

								<!--  END QUOTE DETAILS  -->

								<!--  QUOTE ACTIONS  -->

								<div class="button-container">
									<a
										*ngIf="
											quote.apply_url !== null &&
											!(
												this.quote.quote_status === 'Approved' ||
												this.quote.quote_status === 'ConditionallyApproved'
											)
										"
										class="button button-with-icon-right positive-button apply-button"
										data-element-click="button__engage_configure_finance_options[finance][finance_quote_footer]__positive-button[Apply]"
										(click)="onFinanceAction('apply', quote, $event)"
									>
										<i class="icon-send"></i>
										<span class="text">
											<span>Apply</span>
											<span *ngIf="application_minutes_to_complete" class="time-estimate">approx. {{application_minutes_to_complete | pluralise:'minute':'+s'}}</span>
										</span>
									</a>
									<a
										*ngIf="quote.print_url !== null"
										[attr.href]="quote.print_url"
										target="_blank"
										class="button button-with-icon-right"
										data-element-click="button__engage_configure_finance_options[finance][finance_quote_footer]__primary-button[Print]"
										(click)="onFinanceAction('print', quote, $event)"
									>
										<i class="icon-printer"></i>
										<span class="text">Print</span>
									</a>
									<a
										*ngIf="dealer.demonstration_mode"
										class="button button-with-icon-right"
										data-element-click="button__engage_configure_finance_options[finance][finance_quote_footer]__primary-button[Demo]"
										(click)="onFinanceDemonstration(quote)"
									>
										<i class="icon-chevron-right-circle"></i>
										<span class="text">Demo</span>
									</a>
								</div>

								<!--  END QUOTE ACTIONS  -->
							</div>
						</div>

						<!--  END QUOTES LOOP  -->
					</div>

					<!--  NO QUOTES MESSAGE  -->

					<div *ngIf="finance_quotes === null || finance_quotes.length < 1" class="no-results">
						<div class="heading">
							<h3>No quotes available</h3>
							<p>
								We're sorry, we were unable to retrieve quotes automatically for your selection. Please
								alter your preferences or arrange a callback to discuss your requirements with one of
								our experienced sales staff.
							</p>
						</div>
						<br />
						<div class="button-container">
							<a
								class="button block-button"
								data-element-click="button__engage_configure_finance_options[finance_no_quotes]__primary-button[Arrange Callback]"
								(click)="onArrangeCallback()"
							>
								Arrange Callback
							</a>
						</div>
					</div>

					<!-- END NO QUOTES MESSAGE  -->
				</div>
			</div>

			<div *ngIf="!finance_meta.enabled" class="accordion-item cash-payment active">
				<div class="accordion-item-content">
					<div class="heading align-center">
						<h3>Cash Payment</h3>

						<p>
							We offer competitive finance packages to all of our customers, but if you prefer to fund
							your purchase yourself that's fine.
						</p>

						<p *ngIf="!configure_service.isStepEnabled('delivery_options')">
							Why not reserve now to secure your purchase?
						</p>
					</div>

					<div class="button-container">
						<a
							*ngIf="!configure_service.isStepEnabled('delivery_options')"
							class="button positive-button reserve-button block-button"
							data-element-click="button__engage_configure_finance_options[cash]__positive-button[Reserve Now]"
							(click)="onReserveNow()"
						>
							Reserve Now
						</a>
						<a
							*ngIf="configure_service.isStepEnabled('delivery_options')"
							class="button positive-button continue-button block-button"
							data-element-click="button__engage_configure_finance_options[cash]__positive-button[Continue]"
							(click)="onContinue()"
						>
							Continue
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="finance-tool" *ngIf="showPoweredBy">
			<div class="powered-by">
				Powered by
				<span *ngIf="!show_powered_by_logo">{{ finance_meta.finance_provider_name }}</span>
			</div>

			<div class="provider-logo">
				<img
					*ngIf="show_powered_by_logo"
					[src]="
						'/assets/img/' + finance_meta.finance_provider_name.toLowerCase().replaceAll(' ', '-') + '.png'
					"
					[alt]="finance_meta.finance_provider_name"
					[class.ivendi-logo]="finance_meta.finance_provider_name === 'IVendi'"
					[class.evolution-logo]="finance_meta.finance_provider_name === 'Evolution'"
					[class.motion-logo]="finance_meta.finance_provider_name === 'Motion'"
					[class.smile-car-finance-logo]="finance_meta.finance_provider_name === 'Smile Car Finance'"
					(error)="show_powered_by_logo = false"
					[attr.data-element-view]="
						'finance_provider_logo__engage_configure_finance_options[finance]__[' +
						finance_meta.finance_provider_name +
						']'
					"
				/>
			</div>
		</div>
	</form>

	<!--  END FINANCE FORM  -->
</div>
